import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../views/ReportView/ReportView.module.css";
import { FaRegAddressCard } from "react-icons/fa";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaUserAlt } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { BajaButton, AltaButton } from "../../";

const HeaderReview = ({ data }) => {
  const [user, setUser] = useState(data);
  const navigate = useNavigate();

  const handleEditUser = async (e, dni) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        process.env.REACT_APP_LEALTAD_UPDATE_USER_API,
        {
          id: dni,
        }
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "El usuario se actualizo correctamente",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const handlerNavigateUpdate = (e, data) => {
    e.preventDefault();
    navigate("/lealtad/informe/actualizar", { state: { data } });
  };

  const handlePdf = (e, data) => {
    e.preventDefault();
    navigate("/lealtad/informe/imprimir-pdf", { state: { data } });
  };

  const changeColoResult = () => {
    if (user.Risk.data === "Riesgo bajo") {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrlow}>{user.Risk.data}</p>
        </div>
      );
    } else if (user.Risk.data === "Riesgo medio") {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrmid}>{user.Risk.data}</p>
        </div>
      );
    } else {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrheig}>{user.Risk.data}</p>
        </div>
      );
    }
  };

  return (
    <div className={styles.LealtadInfo}>
      {!user ? (
        <NotReportViewData title="Información" Icon={FaUserAlt} />
      ) : (
        <>
          <div className={styles.LealtadsectionTitle}>
            <div>
              <h2 className={styles.Lealtadtitle}>
                <FaRegAddressCard className={styles.Lealtadicon} /> {user.cuil}{" "}
                |{" " + user.name} {user.lastName}
              </h2>
            </div>
            <div className={styles.LealtadbuttonsContainerfelx}>
              <div className={styles.LealtadbuttonsContainer}>
                {user.status === "Alta" ? (
                  <BajaButton user={user} setUser={setUser} />
                ) : (
                  <AltaButton user={user} setUser={setUser} />
                )}
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  className={styles.Lealtadbutton}
                  onClick={(e) => handlePdf(e, data)}
                >
                  <i className="fa fa-refresh"></i> Imprimir Informe
                </button>
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  className={styles.Lealtadbutton}
                  onClick={(e) => handleEditUser(e, user.dni)}
                >
                  <i className="fa fa-refresh"></i> Actualizar por Nosis
                </button>
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  id={styles.Lealtadidbuton}
                  className={styles.Lealtadbutton}
                  onClick={(e) => handlerNavigateUpdate(e, user)}
                >
                  <i className="fa fa-refresh"></i> Actualizar a Mano
                </button>
              </div>
            </div>
          </div>
          {changeColoResult()}
        </>
      )}
    </div>
  );
};

export default HeaderReview;
